<div class="question">
    <p class="question__subject">
      {{question.question | unescape}}
    </p>
    
    <ul class="question__answers">
      <li class="question__answers__answer"
          [class.question__answers__answer--selected]="selectedAnswer === answer"
          [class.question__answers__answer--correct]="locked && answer === question.correct_answer"
          [class.question__answers__answer--wrong]="locked && selectedAnswer === answer && answer !== question.correct_answer"
          *ngFor="let answer of answers"
          (click)="onSelectAnswer(answer)"
          >{{answer | unescape}}</li>
    </ul>
  </div>